import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col, Form, Collapse } from "react-bootstrap";
import { FUNNEL_DESIGNS } from "../strings";
import { FieldSet, Legend } from "../common-styling";
import TextArea from "../reusable-form-fields/text-area";
import TextField from "../reusable-form-fields/text-field";
import RadioInput from "../reusable-form-fields/input-radio";
import { useTranslation } from "react-i18next";

const ThankYouPageSection = ({ digital = false }) => {
  const { t } = useTranslation();
  const {
    watch,
    register,
    setValue,
    formState: { errors }
  } = useFormContext();
  const redirectLeadWatcher = watch("thankyouPage.redirectLead");
  const addressAfterLeadGenerationWatcher = watch(
    "thankyouPage.enableAddressAfterLeadGeneration"
  );
  const layoutDesignWatcher = watch("funnelDesign") || watch("templateDesign");

  useEffect(() => {
    if (
      addressAfterLeadGenerationWatcher &&
      layoutDesignWatcher === FUNNEL_DESIGNS.MODERN
    ) {
      setValue("thankyouPage.enableAddressAfterLeadGeneration", false);
    }
  }, [setValue, layoutDesignWatcher, addressAfterLeadGenerationWatcher]);

  return (
    <div className="py-3 px-0">
      <FieldSet>
        <Legend>
          <h6 className="mb-0 fw-bold">
            {digital && "Digital "}
            {t("thankyouPage")}
          </h6>
        </Legend>
        {!digital && (
          <div className="px-0">
            <Row className="mb-2">
              <Col xs={12} md={6}>
                <Form.Check
                  role="button"
                  type="switch"
                  className="fw-bold"
                  label={t("redirect.switchLabel")}
                  {...register("thankyouPage.redirectLead", {
                    onChange: () => {
                      if (addressAfterLeadGenerationWatcher) {
                        setValue(
                          "thankyouPage.enableAddressAfterLeadGeneration",
                          false
                        );
                      }
                    }
                  })}
                />
              </Col>
              <Collapse in={redirectLeadWatcher}>
                <Row>
                  <Col xs={12} md={6}>
                    <TextField
                      type="text"
                      register={register}
                      label={t("redirect.fieldLabel")}
                      name="thankyouPage.redirectUrl"
                      placeholder={t("redirect.fieldPlaceholder")}
                      errors={errors?.thankyouPage?.redirectUrl}
                    />
                  </Col>
                </Row>
              </Collapse>
            </Row>
          </div>
        )}
        <Collapse in={!redirectLeadWatcher}>
          <div className="px-0">
            {layoutDesignWatcher === FUNNEL_DESIGNS.CLASSIC && !digital && (
              <>
                <Row className="mb-2">
                  <Col xs={12} md={6} className="fw-bold">
                    <Form.Check
                      role="button"
                      type="switch"
                      className="fw-bold"
                      label={t("addressAfterLeadgen.switchLabel")}
                      {...register(
                        "thankyouPage.enableAddressAfterLeadGeneration",
                        {
                          onChange: () => {
                            if (redirectLeadWatcher) {
                              setValue("thankyouPage.redirectLead", false);
                            }
                          }
                        }
                      )}
                    />
                  </Col>
                </Row>
                <Collapse in={addressAfterLeadGenerationWatcher}>
                  <Row>
                    <Col xs={12} md={6}>
                      <TextField
                        type="text"
                        register={register}
                        name="thankyouPage.addressLabel"
                        label={t("addressAfterLeadgen.fieldLabel")}
                        placeholder={t("addressAfterLeadgen.fieldPlaceholder")}
                        errors={errors?.thankyouPage?.addressLabel}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <TextField
                        type="text"
                        register={register}
                        name="thankyouPage.addressSubmitButtonLabel"
                        label={t("addressAfterLeadgen.submitBtnFieldLabel")}
                        placeholder={t(
                          "addressAfterLeadgen.submitBtnFieldPlaceholder"
                        )}
                        errors={errors?.thankyouPage?.addressSubmitButtonLabel}
                      />
                    </Col>
                  </Row>
                </Collapse>
              </>
            )}
            {!digital && (
              <Row>
                <Col xs={12} md={6}>
                  <RadioInput
                    label={t("websiteBtnForThankyouPage")}
                    firstOptLabel={t("common.yes")}
                    secondOptLabel={t("common.no")}
                    name="thankyouPage.websiteButton"
                    firstValue="Yes"
                    firstValueId="Yes"
                    secondValue="No"
                    secondValueId="No"
                    register={register}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <TextField
                    type="text"
                    register={register}
                    label={t("common.websiteBtnTxt")}
                    name="thankyouPage.websiteButtonText"
                    placeholder={`${t("common.enter")} ${t(
                      "common.websiteBtnTxt"
                    )}`}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} md={6}>
                <TextArea
                  label={`${t("thankyouPage")} ${t("common.headline")}`}
                  name="thankyouPage.thankyouPageHeadline"
                  register={register}
                />
              </Col>
              <Col xs={12} md={6}>
                <TextArea
                  label={`${t("textOnThankyouPage")} ${t("thankyouPage")}`}
                  name="thankyouPage.thankyouPageText"
                  register={register}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <TextArea
                  label={t("greetingPhrase")}
                  name="thankyouPage.greetingPhrase"
                  register={register}
                />
              </Col>
            </Row>
          </div>
        </Collapse>
      </FieldSet>
    </div>
  );
};
export default ThankYouPageSection;
